import { useContext, useEffect, useState } from "react";

import { ITableRowData } from "../../../../shared/components/normal-table/normal-table";
import SimpleModal from "../../../../shared/components/simple-modal/simple-modal";
import AuthContext from "../../../../shared/context/auth-context";
import { useHttpNonTable } from "../../../../shared/hooks/use-httpNonTable";
import { getAllDataNonTable } from "../../../../shared/utils/api";
import DataTable from "../../../components/data-table/data-table";

export interface IPopupConfig {
  show: boolean;
  handlePopupClosed(result: ITableRowData[] | undefined): void;
  preSelectedUserGroups: string[];
  handleUserGroupSelected(result: ITableRowData[]): void;
}

const UserGroupSelectPopup = ({
  show,
  handlePopupClosed,
  handleUserGroupSelected,
  preSelectedUserGroups
}: IPopupConfig) => {
  const authCtx = useContext(AuthContext);
  const [userGroups, setUserGroups] = useState<ITableRowData[]>([]);
  const [selectedUserGroups, setSelectedUserGroups] = useState<string[]>([]);
 
  const {
    sendRequest: getUserGroups,
    status: getUserGroupsStatus,
    data: getUserGroupsData,
    error: getUserGroupsError
  } = useHttpNonTable(getAllDataNonTable, false, authCtx.token, undefined, "platform");

  useEffect(() => {
    getUserGroups("user_groups");
  }, []);

  useEffect(() => {
    if (getUserGroupsData && getUserGroupsStatus === "completed" && !getUserGroupsError) {
      setUserGroups(getUserGroupsData);
    }
  }, [getUserGroupsData, getUserGroupsStatus, getUserGroupsError]);

  useEffect(() => {
    if (preSelectedUserGroups) {
      setSelectedUserGroups(preSelectedUserGroups);
    }
  }, [preSelectedUserGroups]);
  
  const handleOnSelectionChange = (selectedIds: string[]) => {
    setSelectedUserGroups(selectedIds);
  };

  const handleSubmit = () => {
    const filteredUserGroups: ITableRowData[] = userGroups.filter((userGroup: ITableRowData) => 
      selectedUserGroups.includes(userGroup.id)
    );
    handleUserGroupSelected(filteredUserGroups);
  };

  const modalContent = () => {
    return (
      <DataTable
        columns={[
          {
            key: "name",
            displayName: "Name",
            dataType: {
              type: "text",
            },
          },
        ]}
        dataUrl={{
          url: "user_groups",
          backend: "platform",
        }}
        defaultSortCol="name"
        selectionMode="multi"
        onSelectionChange={handleOnSelectionChange}
        preSelectedIds={selectedUserGroups}
        isRowClickable={false}
      />
    );
  };

  return (
    <SimpleModal
      modalBody={modalContent()}
      mode={"User Group List"}
      handleModalClosed={() => handlePopupClosed(undefined)}
      handleSubmit={handleSubmit}
      show={show}
      buttonText="Save"
    />
  );
};

export default UserGroupSelectPopup;
